import { devtools, persist } from 'zustand/middleware';

import create from 'zustand';

import { TabStoreState } from './useTab.type';

const useTab = create<TabStoreState>()(
  devtools(
    persist(
      (set) => ({
        selectedTab: '',
        setSelectedTab: (tab) => set(() => ({ selectedTab: tab })),
      }),
      {
        name: 'tab-storage',
      },
    ),
  ),
);

export default useTab;
